<template>
  <b-card
    no-body
    class="card-company-table"
    style="flex: 1"
  >
    <b-table
      :items="tableData"
      responsive
      :fields="fields"
      class="mb-0"
      empty-text="Não há registros para as campanhas informadas"
      show-empty
    >
      <!-- nome da campanha -->
      <template #cell(name)="data">
        <div class="d-flex align-items-center">
          <div>
            <div class="font-weight-bolder">
              {{ data.item.campaignName }}
            </div>
          </div>
        </div>
      </template>

      <!-- tipo de campanha -->
      <template #cell(campaignType)="data">
        <div class="d-flex align-items-center">
          <b-avatar
            class="mr-1"
            :variant="data.item.campaignType === 'leadGenerate' ? 'light-info' : 'light-warning'"
          >
            <feather-icon
              size="18"
              :icon="data.item.campaignType === 'leadGenerate' ? 'UserIcon' : 'CodeIcon'"
            />
          </b-avatar>
          <span>{{ data.item.campaignType === "leadGenerate" ? 'Geração de lead' : 'Código de indicador' }}</span>
          <!-- <span>{{ data.item.campaignType === "voucher" ? 'Cupom' : 'Dinheiro' }}</span> -->
        </div>
      </template>

      <!-- leads -->
      <template #cell(leads)="data">
        <span class="d-flex align-items-center justify-content-center font-weight-bolder mb-25 text-center">{{ data.item.leads }}</span>
      </template>

      <!-- vendas -->
      <template #cell(sales)="data">
        <span class="d-flex align-items-center justify-content-center font-weight-bolder mb-25 text-center">{{ data.item.sales }}</span>
      </template>

      <!-- conversion -->
      <template #cell(conversion)="data">
        <span class="d-flex align-items-center justify-content-center font-weight-bolder mr-1 text-center">{{ data.item.conversion+'%' }}</span>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable,
  BAvatar,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    // BImg,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fields: [
        { key: 'campaignToken', label: 'CÓDIGO DA CAMPANHA' },
        { key: 'campaignName', label: 'CAMPANHA' },
        { key: 'campaignType', label: 'TIPO DE CAMPANHA' },
        { key: 'rewardDescription', label: 'RECOMPENSA' },
        { key: 'leads', label: 'LEADS' },
        { key: 'sales', label: 'VENDAS' },
        { key: 'conversion', label: '% CONVERSÃO' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
